import PopUp from "../core/PopUp.tsx";
import { IconLogin } from "@tabler/icons-react";
import LoginForm from "./LoginForm.tsx";

export const MODAL_LOGIN_ID = "login-pop-up";
const LoginModal = () => {
  return (
    <PopUp
      id={MODAL_LOGIN_ID}
      title={
        <>
          <IconLogin />
          Anmelden
        </>
      }
    >
      <LoginForm />
    </PopUp>
  );
};
export default LoginModal;
